import { render, staticRenderFns } from "./form.vue?vue&type=template&id=6d73b686&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d73b686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d73b686')) {
      api.createRecord('6d73b686', component.options)
    } else {
      api.reload('6d73b686', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=6d73b686&scoped=true&", function () {
      api.rerender('6d73b686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formCom/form.vue"
export default component.exports